import { useQuery } from "@tanstack/react-query";
import {
  TransactionStatus,
  type TransactionStatusResponse,
  getTransactionsStatus,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const TRANSACTION_STATUS_QUERY_KEY = "TRANSACTION_STATUS";

// Nothing changes after these — polling a failed transaction every second only burned requests.
const TERMINAL_STATUSES = [
  TransactionStatus.Success,
  TransactionStatus.Fail,
  TransactionStatus.Cancelled,
];

export const transactionStatusKeys = {
  all: [TRANSACTION_STATUS_QUERY_KEY],
  byPublicId: (publicID?: string) => [...transactionStatusKeys.all, publicID],
};

export const useTransactionStatus = (
  publicID: string,
  { enabled }: { enabled: boolean } = { enabled: true },
) =>
  useQuery<TransactionStatusResponse>({
    queryKey: transactionStatusKeys.byPublicId(publicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionsStatus(publicID),
    ),
    refetchInterval: (data) => {
      const transactionStatus = data.state.data?.transactionStatus;
      const isTerminal =
        !!transactionStatus && TERMINAL_STATUSES.includes(transactionStatus);
      if (data.state.error || isTerminal) {
        return false;
      }

      // Manual review resolves in hours, not seconds — and the anonymous page has no SignalR to tell it.
      if (transactionStatus === TransactionStatus.InvestigationNeeded) {
        return MS_TIME.halfMinute;
      }

      return MS_TIME.second; // TEMPORARY: Fallback polling (TODO: Fix SignalR real-time updates)
    },
    enabled,
  });
